const state = {
  paginationLimit: [5, 10]
}

const actions = {

}

const mutations = {

}

const getters = {
  paginationLimit: (state) => state.paginationLimit
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
